import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonAssociationCardContentComponent } from '@galaxy/crm/static';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export interface DialogData {
  name: string;
  companyName: string;
  businessAppName$: Observable<string>;
}

@Component({
  selector: 'app-crm-invite-to-business-app',
  templateUrl: './invite-to-business-app.component.html',
  styleUrls: ['./invite-to-business-app.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    CommonAssociationCardContentComponent,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
  ],
  standalone: true,
})
export class InviteToBusinessAppComponent {
  contactName: string;
  companyName: string;
  businessAppName$: Observable<string>;

  constructor(
    private dialogRef: MatDialogRef<InviteToBusinessAppComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.contactName = data.name;
    this.companyName = data.companyName;
    this.businessAppName$ = data.businessAppName$;
  }

  invite(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
